<template>
  <!-- 版本管理 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item :label="$t('pages.system.text1')">
          <el-input
            v-model="searchParams.version"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text2')">
          <el-select
            v-model="searchParams.status"
            :placeholder="$t('public.text5')"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text3')">
          <el-date-picker
            v-model="searchParams.startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            @change="startChange"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
          <span style="margin: 0 8px">-</span>
          <el-date-picker
            v-model="searchParams.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['versionManagement:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['versionManagement:reset']"
        ></DiluButton>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="operation">
      <DiluButton
        type="add"
        @click="add"
        v-permission="['versionManagement:add']"
      ></DiluButton>
      <DiluButton
        type="delete"
        @click="remove"
        v-permission="['versionManagement:remove']"
        v-if="selectIds.length > 0"
      ></DiluButton>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :total="total"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      @handleSelectionChange="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="date" label="#" width="55" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="version"
        :label="$t('pages.system.text1')"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="fileName"
        :label="$t('pages.system.text4')"
        width="210"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="fileSize"
        :label="$t('pages.system.text5')"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ sizeReset(scope.row.fileSize) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdBy"
        :label="$t('pages.system.text6')"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="recentlyAt"
        :label="$t('pages.system.text3')"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('pages.system.text2')"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.status == 0">{{
              $t("pages.system.text7")
            }}</span>
            <span v-if="scope.row.status == 1">{{
              $t("pages.system.text8")
            }}</span>
            <span v-if="scope.row.status == 2">{{
              $t("pages.system.text9")
            }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="reviewerId"
        :label="$t('pages.system.text10')"
        align="center"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="reviewPassTime"
        :label="$t('pages.system.text11')"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        width="100"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button
              @click="see(scope.row)"
              type="text"
              v-permission="['versionManagement:see']"
              >{{ $t("button.look") }}</el-button
            >
            <el-button
              @click="edit(scope.row)"
              type="text"
              :disabled="scope.row.status != 0"
              v-permission="['versionManagement:edit']"
              >{{ $t("button.edit") }}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 新增弹窗 -->
    <VersionManageAddModule
      @dialogClose="dialogClose"
      :dialogVisible="dialogVisible"
      @versionManagementList="versionManagementList"
      :currentVersionManage="currentVersionManage"
      :dialogStatus="dialogStatus"
    />

    <!-- 查看弹窗 -->
    <VersionManagementLookUp
      :lookUpVisible="lookUpVisible"
      @lookUpClose="lookUpClose"
      :lookUpData="lookUpData"
    />
  </div>
</template>

<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import VersionManageAddModule from "./module/versionManageAddModule.vue";
import VersionManagementLookUp from "./module/versionManagementLookUp.vue";
import { resetDate } from "../../../utils/util/validate";
import { mapState } from "vuex";
import { sizeReset } from "../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.searchParams.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      currentVersionManage: {}, //当前版本
      dialogStatus: 0, //0新增 1编辑
      lookUpData: {},
      searchParams: {
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        startAt: "", //版本查询开始时间
        stopAt: "", //版本查询结束时间
        status: "", //	状态,0代表未审核，1代表审核通过，2代表审核失败
        version: "", //版本号
        appCode: "",
      },
      options: [
        {
          value: "0",
          label: this.$t("pages.system.text7"),
        },
        {
          value: "1",
          label: this.$t("pages.system.text8"),
        },
        {
          value: "2",
          label: this.$t("pages.system.text9"),
        },
      ],
      total: 0,
      value: "",
      dialogVisible: false, //新增编辑弹窗
      lookUpVisible: false, //查看弹窗
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      tableData: [],
      selectIds: [],
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluTable,
    DiluButton,
    VersionManageAddModule,
    VersionManagementLookUp,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {
    this.versionManagementList();
  },
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.versionManagementList();
    },
    sizeReset(e) {
      return sizeReset(e);
    },
    startChange() {
      this.searchParams.stopAt = null;
    },
    //编辑
    edit(e) {
      this.currentVersionManage = e;
      this.dialogStatus = 1;
      this.dialogVisible = true;
    },
    //关闭查看弹窗
    lookUpClose() {
      this.lookUpVisible = false;
    },
    see(e) {
      this.lookUpData = e;
      this.lookUpVisible = true;
    },
    //选中
    handleSelectionChange(e) {
      this.selectIds = e.map((item) => {
        return item.id;
      });
    },
    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams = {
          pageNum: 1, //页码
          pageSize: 10, //每页条数
          startAt: "", //版本查询开始时间
          stopAt: "", //版本查询结束时间
          status: "", //	状态,0代表未审核，1代表审核通过，2代表审核失败
          version: "", //版本号
        };
      }
      this.searchParams.pageNum = e;
      this.versionManagementList();
    },
    //关闭新增编辑弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    //新增
    add() {
      this.dialogStatus = 0;
      this.dialogVisible = true;
    },
    //删除
    remove() {
      this.$confirm(this.$t("pages.system.text12"), this.$t("public.text6"), {
        confirmButtonText: this.$t("button.determine"),
        cancelButtonText: this.$t("button.cancel"),
        type: "warning",
      })
        .then(() => {
          let arr = this.selectIds;
          this.request.versionManagementDelete({ ids: arr }).then(() => {
            this.$message.success(this.$t("public.text7"));
            this.total = 0;
            this.searchParams.pageNum = 1;
            this.versionManagementList();
          });
        })
        .catch(() => {});
    },
    //重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        startAt: "", //版本查询开始时间
        stopAt: "", //版本查询结束时间
        status: "", //	状态,0代表未审核，1代表审核通过，2代表审核失败
        version: "", //版本号
      };
      this.total = 0;
      this.versionManagementList();
    },
    //APP版本-分页列表查询
    versionManagementList() {
      this.searchParams.appCode = this.platformData.appCode;
      if (this.searchParams.startAt) {
        if (!this.searchParams.stopAt) {
          return this.$message.error(this.$t("public.text3"));
        }
      }
      if (this.searchParams.stopAt) {
        if (!this.searchParams.startAt) {
          return this.$message.error(this.$t("public.text2"));
        }
      }
      if (this.searchParams.stopAt && this.searchParams.startAt) {
        this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 结束时间
        this.searchParams.startAt = resetDate(this.searchParams.startAt); // 开始时间
      }

      this.request.versionManagementList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>